import * as React from 'react';

// We default to true so that global logic outside the screen rendering is not impacted and always considered as active.
export const NavigationIsCurrentScreenContext = React.createContext<boolean>(true);
export const NavigationPassiveIsCurrentScreenContext = React.createContext<
    React.RefObject<boolean>
>({
    current: true,
});

/**
 * Hook to know if we are rendering the current screen.
 */
export function useIsCurrentScreen(): boolean {
    return React.useContext(NavigationIsCurrentScreenContext);
}

/**
 * Hook to know if we are rendering the current screen in a passie way (do not re-render component when changed).
 * This method is useful when we want to know in a callback if it's current screen but the render result doesn't depend on it.
 */
export function usePassiveIsCurrentScreen(): React.RefObject<boolean> {
    return React.useContext(NavigationPassiveIsCurrentScreenContext);
}
